module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question4.423b4991.jpg";